import {ThreeTsl as TSL} from "#material/three/exports"
import type {RgbToBwSockets} from "#material/nodes/converter/rgb-to-bw/definition"
import {rgbToBwDefinition} from "#material/nodes/converter/rgb-to-bw/definition"
import {registerMaterialGraphNode} from "#material/register"
import {threeConvert, threeRGBColor} from "#material/three/three-utils"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {cyclesColor} from "#material/cycles/helpers"
import type {ThreeReturns} from "#material/sockets/three"
import type {RgbToBwNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class RgbToBw extends MaterialNode<RgbToBwSockets> {
    public override get definition() {
        return rgbToBwDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<RgbToBwSockets>> => {
        const colorValue =
            (await evaluator.get(this.parameters.inputs.color))?.toColor() ??
            threeConvert(this.parameters.settings.color, threeRGBColor) ??
            threeRGBColor({r: 0, g: 0, b: 0})

        return {val: TSL.color(TSL.luminance(colorValue.rgb))}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<RgbToBwSockets>> => {
        const rgbToBwNode: RgbToBwNode = {
            type: "rgb_to_bw",
            inputs: {color: await evaluator.get(this.parameters.inputs.color)},
            parameters: {color: cyclesColor(this.parameters.settings.color)},
            resources: {},
        }

        return {
            val: [rgbToBwNode, "val"],
        }
    }
}
